import { get } from "./";
import { Query } from "../screens/Audits/types";

export function paginate(
  owner?: string,
  query: Partial<Query> = { limit: 10, page: 1 }
) {
  return get(`${owner}history`, query);
}
